import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0264f778&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0264f778')) {
      api.createRecord('0264f778', component.options)
    } else {
      api.reload('0264f778', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0264f778&", function () {
      api.rerender('0264f778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/backup/index.vue"
export default component.exports